import React from 'react';

export type CardOption = {
  value: string;
  label: string;
  description?: string;
  icon?: React.ComponentType<{ className?: string }>;
};

interface CardMultiSelectProps {
  options: CardOption[];
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}

export function CardMultiSelect({ options, value, onChange, disabled }: CardMultiSelectProps) {
  const toggleOption = (optionValue: string) => {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
      {options.map((option) => {
        const isSelected = value.includes(option.value);

        return (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            onClick={() => toggleOption(option.value)}
            className={
              `flex items-center p-2.5 sm:p-3 rounded-lg border transition-colors text-sm sm:text-base ` +
              (isSelected
                ? 'border-[#E34290] ring-2 ring-[#E34290] bg-[#E34290]/5'
                : 'border-gray-200 dark:border-gray-700 hover:border-[#E34290]/60 hover:bg-gray-50 dark:hover:bg-gray-800') +
              (disabled ? ' opacity-60 cursor-not-allowed' : '')
            }
          >
            <div className="flex-1 text-left">
              <div className="font-medium text-gray-900 dark:text-gray-100">{option.label}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
